<template>
  <div>
    <AlbumDetails />
  </div>
</template>

<script>
// @ is an alias to /src
import AlbumDetails from '@/components/AlbumDetails.vue'

export default {
  name: 'albumdetails',
  components: {
    AlbumDetails
  }
}
</script>
